import { READ_DEVICES_SCOPE, READ_LOCATIONS_SCOPE, READ_MODERATION_EVENTS_SCOPE } from '../../constants'
import { AppRoute } from '../../auth/routeAuth'
import { MonitoringModerationPage } from './MonitoringModerationPage'
import { CameraOverviewPage } from './CameraOverviewPage'

/**
 * Note: Top-level components need to render a Page Component
 */
export const monitoringModerationRoutes: AppRoute[] = [
  {
    index: true,
    element: <MonitoringModerationPage />
  },
  {
    path: 'camera-overview/:cameraId?',
    element: <CameraOverviewPage />,
    auth: { scopes: [READ_LOCATIONS_SCOPE, READ_DEVICES_SCOPE, READ_MODERATION_EVENTS_SCOPE], mode: 'all' }
  }
]
